import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import { findPreactivation } from 'actions/preactivations';
import { findUser } from 'actions/users';
import {
  getUser,
  getPreactivation,
  getIncludedInGroups,
  getLoggedInUser,
} from 'reducers';

const withPreactivation = (DecoratedComponent) => {
  let WithPreactivation = ({ children, ...props }) => {
    return React.createElement(DecoratedComponent, props, children);
  };

  const mapStateToProps = (
    state,
    {
      match: {
        params: { preactivationId },
      },
      location: { search },
    },
  ) => {
    const preactivation = getPreactivation(state, preactivationId);
    const user = getUser(state, preactivation && preactivation.user_profile);
    return {
      preactivationId,
      preactivation,
      user,
      loggedInUser: getLoggedInUser(state),
      isReseller: getIncludedInGroups(state, ['RESELLER']),
      isResellerOrAdminOrManager: getIncludedInGroups(state, [
        'RESELLER',
        'ADMIN',
        'MANAGER',
      ]),
    };
  };

  const mapDispatchToProps = {
    findPreactivation,
    findUser,
  };

  WithPreactivation = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(WithPreactivation),
  );

  const WithPreactivationRoute = ({ children, ...props }) => (
    <Route
      path="/preactivations/:preactivationId"
      component={WithPreactivation}
      {...props}
    />
  );

  return WithPreactivationRoute;
};

export default withPreactivation;
